import { Injectable } from '@angular/core';
import Resources from '@constants/resourses';
import { SessionService } from './session.service';

@Injectable({ providedIn: 'root' })
export class SpotlightTrackingService {
  private clickedSpotlightsByTariff = new Map<string, Set<string>>();

  constructor(private sessionService: SessionService) {
    // Restore any clicks recorded earlier in this session (e.g. before a page reload)
    const stored: Record<string, string[]> = this.sessionService.getItemFromSession(Resources.SessionStorageKeys.SpotlightClicks) || {};
    Object.keys(stored).forEach(tariffName => {
      this.clickedSpotlightsByTariff.set(tariffName, new Set(stored[tariffName]));
    });
  }

  // Records that a given spotlight (e.g. 'spotlight_cheapest') was clicked for a tariff.
  // Keyed by tariff name rather than PriceId, since PriceId is regenerated on every quote fetch.
  recordClick(tariffName: string | undefined, spotlightEvent: string): void {
    if (!tariffName) {
      return;
    }

    const spotlights = this.clickedSpotlightsByTariff.get(tariffName) ?? new Set<string>();
    spotlights.add(spotlightEvent);
    this.clickedSpotlightsByTariff.set(tariffName, spotlights);

    this.persistToSession();
  }

  // Returns every spotlight clicked so far for a tariff, e.g. ['spotlight_cheapest', 'spotlight_current_provider']
  getClickedSpotlights(tariffName: string | undefined): string[] {
    if (!tariffName) {
      return [];
    }

    // Sync with session storage first, in case it holds clicks not yet reflected in memory
    const stored: Record<string, string[]> = this.sessionService.getItemFromSession(Resources.SessionStorageKeys.SpotlightClicks) || {};
    const spotlights = this.clickedSpotlightsByTariff.get(tariffName) ?? new Set<string>();
    (stored[tariffName] ?? []).forEach(spotlight => spotlights.add(spotlight));
    this.clickedSpotlightsByTariff.set(tariffName, spotlights);

    return Array.from(spotlights);
  }

  private persistToSession(): void {
    const plain: Record<string, string[]> = {};
    this.clickedSpotlightsByTariff.forEach((spotlights, tariffName) => {
      plain[tariffName] = Array.from(spotlights);
    });

    this.sessionService.setItemIntoSession(Resources.SessionStorageKeys.SpotlightClicks, plain);
  }
}
